<template>
    <section class="contact-us">
      <ul>
        <li class="contact-qq">
          <p class="contact-us-icon qq"></p>
          <div class="qq-panel Panel" >
            <div class="qq-list">
              <a target="_blank" href="http://p.qiao.baidu.com/cps/chat?siteId=10090048&userId=22278208" alt="在线咨询" title="在线咨询">
                <div class="contact-qq-icon"></div>
                <p class="dt-f12">在线咨询</p>
              </a>
              <a target="_blank" class="contact-tel-a" href="tel:15201338330">
						<div class="contact-tel-icon"></div>
						<p class="dt-f12">15201338330</p>
				</a>
            </div>
          </div>
        </li>
        <li class="contact-email">
          <p class="contact-us-icon email"></p>
          <div class="email-panel Panel">
            <div class="email-list">
              <a href="mailto:bd@leador.com.cn" >
                <div class="contact-email-icon"></div>
                <div class="contact-email-text">
                  <p class="dt-f14 contact-us-header">商务合作</p>
                  <p class="dt-f12 mailName">bd@leador.com.cn</p>
                </div>
              </a>
            </div>
          </div>
        </li>
        <li class="contact-rqcode hidden-xs">
          <p class="contact-us-icon rqcode"></p>
          <div class="rqcode-panel Panel">
            <div class="rqcode-list">
              <p class="scan">【扫一扫】立即关注</p>
              <div class="pull-left">
                <div class="contact-rqcode-icon wechat"></div>
                <p class="dt-mar8t color66 dt-f12">微信公众号</p>
              </div>
              <div class="pull-right">
                <div class="contact-rqcode-icon sina"></div>
                <p class="dt-mar8t color66 dt-f12">新浪微博</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
</template>
<style lang="less" rel="stylesheet/less">
  .contact-us {
    position: fixed;
    width: 48px;
    height: 176px;
    right: 12px;
    top: 60%;
    z-index: 99;
    font-family:'Microsoft Yahei';
    .dt-f12 {
      color: #337ab7;
      font-size: 12px;
    }
    .dt-f14 {
      font-size: 14px;
    }
    .pull-left {
      float: left;
    }
    .pull-right {
      float: right;
    }
    .color66 {
      color: #666;
      line-height: 1.5rem;
    }
    .contact-us-icon {
      width: 48px;
      height: 48px;
      background: url(../../static/images/contact-us/iconnormal.png);
    }
    li {
      margin-bottom: 12px;
      cursor: pointer;
      list-style: none;
      .qq-panel {
        position: absolute;
        top: -20px;
        right: 40px;
        display: none;
        padding-right: 14px;
        .qq-list {
          width: 137px;
          height: 172px;
          background: url(../../static/images/contact-us/onlinebox.png);
          .contact-tel-a {
            p {
                bottom: 10px;
                top: auto;
                left: 20px;
            }
        }
          .contact-qq-icon {
            width: 50px;
            height: 50px;
            position: absolute;
            left: 34px;
            top: 8px;
            background-position: 0 0;
            background: url(../../static/images/contact-us/online.png);
            &:hover {
               background-position: 50px 0;
             }
          }
          .contact-tel-icon {
            width: 50px;
            height: 50px;
            position: absolute;
            left: 34px;
            bottom: 34px;
            background-position: 0 0;
            background: url(../../static/images/contact-us/tel.png);
          &:hover {
            background-position: 50px 0;
          }
        }
          p {
            position: absolute;
            left: 32px;
            top: 60px;
          }
          .tel {
            position: absolute;
            left: 32px;
            top: 92px;
            color: #333;
            &-num {
               position: absolute;
               left: 16px;
               top: 112px;
               color: #333;
             }
          }
        }
      }
      .email-panel {
        position: absolute;
        top: 48px;
        right: 40px;
        display: none;
        padding-right: 14px;
        .email-list {
          width: 228px;
          height: 73px;
          background: url(../../static/images/contact-us/emailbox.png);
          .contact-email-icon {
            width: 38px;
            height: 38px;
            position: absolute;
            left: 20px;
            top: 15px;
            background-position: 0 0;
            background: url(../../static/images/contact-us/email.png);
            &:hover {
               background-position: 38px 0;
             }
          }
          .contact-email-text{
            position: absolute;
            left: 70px;
            top: 16px;
            p{
              margin: 0;
              line-height: 1.2em;
            }
            .contact-us-header{
              color: #1e85c5;
              text-align: left;
            }
            .mailName{
              color: #333;
              text-decoration: underline;
            }
          }
          .email-num {
            position: absolute;
            left: 16px;
            top: 112px;
            color: #333;
          }
        }
      }
      .rqcode-panel {
        position: absolute;
        top: 58px;
        right: 40px;
        display: none;
        padding-right: 14px;
        .rqcode-list {
          width: 290px;
          height: 174px;
          background: url(../../static/images/contact-us/codebox.png);
          padding: 30px;
          padding-top: 10px;
          padding-right: 40px;
          .scan{
            color: #1e85c5;
            font-size: 14px;
            margin-bottom:13px;
          }
          .contact-rqcode-icon{
            width: 96px;
            height: 96px;
            background: url(../../static/images/contact-us/code.png);

          }
          .contact-rqcode-icon.wechat{
            background-position: 0 0;
          }
          .contact-rqcode-icon.sina{
            background-position: -96px 0;
          }
          p{
            text-align: center;
            font-size: 12px;
            margin-top: 5px;
          }
        }
      }
      }
    .contact-qq:hover .qq-panel {
      display: block;
    }
    .contact-email:hover .email-panel {
      display: block;
    }
    .contact-rqcode:hover .rqcode-panel {
      display: block;
    }
    .qq {
      background-position: 0 0;
      &:hover{
         background-position: 0 0;
       }
    }
    .email {
      background-position: -48px 0;
      &:hover{
         background-position: -48px 0;
       }
    }
    .rqcode {
      background-position: -96px 0;
      &:hover{
         background-position: -96px 0;
       }
    }
  }
  @media (max-width: 1024px){
  	.contact-us{
  		top:83%;
  		.hidden-xs{
  			display: none;
  		}
  	}
  	
  }
 
  .active{
  	display: block;
  }
</style>
	
<script >
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?c7a3934d099051738c6e4e935d672a79";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>



// WEBPACK FOOTER //
// contactUs.vue?3c96b300